import getLang from 'I18n/utils/getLang';
import Raven from 'raven-js';
import { useSearchQuery } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.hooks';
import { StringFilterQueryTypename } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
export const useGetOfferingDetails = ({
  appId,
  skip
}) => {
  var _data$cards;
  const {
    data,
    loading,
    error
  } = useSearchQuery({
    variables: {
      language: getLang(),
      filter: {
        filterGroups: [{
          filtersByField: {
            SOURCE_ID: [{
              values: [String(appId)],
              clause: 'OR',
              __typename: StringFilterQueryTypename
            }]
          }
        }]
      }
    },
    skip: !appId || skip,
    onError: err => {
      Raven.captureException(err);
    }
  });
  return {
    data: data === null || data === void 0 || (_data$cards = data.cards) === null || _data$cards === void 0 ? void 0 : _data$cards[0],
    loading,
    error
  };
};